import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Box, Grid, Button, TextField, FormControl, InputLabel, Select, Autocomplete, MenuItem, Paper, Typography, InputAdornment
} from "@mui/material";
import { toast } from "react-toastify";
import moment from "moment";
import axiosInstance from "../../../lib/axios";
import UnLock from "../../../GlobalFunction/UnLock";
import SearchIcon from '@mui/icons-material/Search';
import { Add as AddIcon } from "@mui/icons-material";
import RefreshIcon from '@mui/icons-material/Refresh';
import { getRoomMasterdropdata } from '../../../Api/PropertyMst/Api'

const GRNStep1 = ({
  index, mode, CompanyData, AllTextDisabled, stepToNext, AllfieldStepperData,
  Flag, fetchGoodsData, GooodsId, addModeDis, viewModeDis,
}) => {
  const { register, setValue, reset, watch, handleSubmit } = useForm({
    defaultValues: {
      PropertyId: '',
      SgrnNo: '',
      SgrnDt: moment().format("YYYY-MM-DD"),
      RefNo: '',
      PartyId: '',
      PartyDtlId: '',
      ActualPartyId: '',
      ActualPartyDtlId: '',
      ChallanNo: '',
      ChallanDt: moment().format("YYYY-MM-DD"),
      TrspId: '',
      LrNo: '',
      LrDt: moment().format("YYYY-MM-DD"),
      Amount: "0.00",
      Quantity: "0.00",
      BrokerId: '',
      Remark: '',
    },
  });
  const [transportDrp, setTransportDrp] = useState([]);
  const [brokerDrp, setBrokerDrp] = useState([]);
  const [supplierDrp, setSupplierDrp] = useState([]);
  const [branchDrp, setBranchDrp] = useState([]);
  const [todayDate] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const [actualBranchDrp, setActualBranchDrp] = useState([]);
  const userId = sessionStorage.getItem('UserId');
  const [propoption, setPropoption] = useState([])
  const [selectedProperty, setSelectedProperty] = useState(null);

  const openNewTab = () => {
    window.open("/partymaster");
  };
  const openTransportTab = () => {
    window.open("")
  }
  const openBranchTab = () => {
    window.open("");
  }
  const handleRefreshSuppliers = () => {
    fetchSuppliers();
  };

  const handleRefreshTransporters = () => {
    fetchTransporters();
  };

  const handleRefreshBrokers = () => {
    fetchBrokers();
  };

  useEffect(() => {
    const initializeForm = () => {
      if (mode === "view" && CompanyData.length > 0) {
        resetFunc(CompanyData[0]);
      } else if (mode === "add") {
        if (!Flag) {
          resetFunc({ Amount: "0.00", Quantity: "0.00" });
        } else {
          resetFunc(AllfieldStepperData);
        }
      } else if (mode === "edit") {
        resetFunc(AllfieldStepperData);
      }
    };
    if (propoption.length > 0) {
      initializeForm();
    }
  }, [CompanyData, mode, Flag, AllfieldStepperData, propoption]);

  useEffect(() => {
    fetchSuppliers()
    fetchTransporters()
    fetchBrokers()
  }, []);

  const fetchSuppliers = async () => {
    try {
      const response = await axiosInstance.post("PartyMst/getPartyMstdrp", {
        PartyCat: "SU",
      });
      if (response.data.Status === 0) {
        setSupplierDrp(response.data.Data || []);
      } else {
        toast.info(response.data.Message || "No suppliers found");
      }
    } catch (error) {
      toast.error("Failed to fetch suppliers");
    }
  };

  const fetchBranches = async (supplierId) => {
    if (!supplierId) {
      setBranchDrp([]);
      setValue("PartyDtlId", "");
      setValue("ActualPartyDtlId", "");
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.post("PartyMst/getdrpPartyMstDtl", {
        PartyId: supplierId,
      });
      if (response.data.Status === 0) {
        const branches = response.data.Data || [];
        setBranchDrp(branches);
        if (branches.length > 0) {
          setValue("PartyDtlId", branches[0].Id);
        }

      } else {
        toast.info(response.data.Message || "No branches found for this supplier");
        setBranchDrp([]);
        setValue("PartyDtlId", "");
      }
    } catch (error) {
      toast.error("Failed to fetch branches");
      setBranchDrp([]);
      setValue("PartyDtlId", ""); // Clear on error
      setValue("ActualPartyDtlId", "");
    } finally {
      setLoading(false);
    }
  };
  const fetchActualBranches = async (supplierId) => {
    if (!supplierId) {
      setActualBranchDrp([]);
      setValue("ActualPartyDtlId", "");
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.post("PartyMst/getdrpPartyMstDtl", {
        PartyId: supplierId,
      });

      if (response.data.Status === 0) {
        const branches = response.data.Data || [];
        setActualBranchDrp(branches);

        // Auto-select first branch if available
        if (branches.length > 0) {
          setValue("ActualPartyDtlId", branches[0].Id);
        }
      } else {
        toast.info(response.data.Message || "No branches found for actual supplier");
        setActualBranchDrp([]);
        setValue("ActualPartyDtlId", "");
      }
    } catch (error) {
      toast.error("Failed to fetch actual branches");
      setActualBranchDrp([]);
      setValue("ActualPartyDtlId", "");
    } finally {
      setLoading(false);
    }
  };
  const fetchTransporters = async () => {
    try {
      const response = await axiosInstance.post("PartyMst/getPartyMstdrp", {
        PartyCat: "TR",
        Flag: "",
      });
      if (response.data.Status === 0) {
        setTransportDrp(response.data.Data || []);
      } else {
        toast.info(response.data.Message || "No transporters available");
      }
    } catch (error) {
      toast.error("Failed to fetch transporters");
    }
  };
  const fetchBrokers = async () => {
    try {
      const response = await axiosInstance.post("PartyMst/getPartyMstdrp", {
        PartyCat: "BR",
        Flag: "",
      });
      if (response.data.Status === 0) {
        setBrokerDrp(response.data.Data || []);
      } else {
        toast.info(response.data.Message || "No brokers available");
      }
    } catch (error) {
      toast.error("Failed to fetch brokers");
    }
  };
  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "PartyId" && value.PartyId) {
        setValue("ActualPartyId", value.PartyId);
        fetchBranches(value.PartyId);
        // Also fetch branches for actual supplier (which is now same as main)
        fetchActualBranches(value.PartyId);
      }

    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (branchDrp.length > 0 && !watch("PartyDtlId")) {
      const firstBranchId = branchDrp[0].Id;
      setValue("PartyDtlId", firstBranchId);
      setValue("ActualPartyDtlId", firstBranchId);
    } else if (branchDrp.length === 0) {
      setValue("PartyDtlId", "");
      setValue("ActualPartyDtlId", "");
    }
  }, [branchDrp, setValue, watch]);

  const resetFunc = (data = {}) => {
    const partyId = data.PartyId || "";
    const partyDtlId = data.PartyDtlId || "";
    const actualPartyId = data.ActVendId || "";
    const actualPartyDtlId = data.ActVendDtlId || "";
    const propId = data.PropId;
    const propertyToSelect = propoption.find(prop => prop.id === propId) || null;
    reset({
      SgrnNo: data.SgrnNo || "",
      SgrnDt: data.SgrnDt ? moment(data.SgrnDt).format("YYYY-MM-DD") : todayDate,
      RefNo: data.RefNo || "",
      PartyId: partyId,
      PartyDtlId: partyDtlId,
      ActualPartyId: actualPartyId,
      ActualPartyDtlId: actualPartyDtlId,
      ChallanNo: data.ChallanNo || "",
      ChallanDt: data.ChallanDt ? moment(data.ChallanDt).format("YYYY-MM-DD") : todayDate,
      TrspId: data.TrspId || "",
      LrNo: data.LrNo || "",
      LrDt: data.LrDt ? moment(data.LrDt).format("YYYY-MM-DD") : todayDate,
      Amount: data.Amount !== undefined ? String(data.Amount) : "0.00",
      Quantity: data.Quantity !== undefined ? String(data.Quantity) : "0.00",
      BrokerId: data.BrokerId || "",
      Remark: data.Remark || "",
      PropertyId: propId,
    });
    if (propertyToSelect) {
      setSelectedProperty(propertyToSelect);
    } else if (propoption.length > 0) {
      setSelectedProperty(propoption[0]);
      setValue("PropertyId", propoption[0].id);
    }
    if (partyId) {
      fetchBranches(partyId);
    } else {
      setBranchDrp([]);
    }
    if (actualPartyId) {
      fetchActualBranches(actualPartyId);
    } else {
      setActualBranchDrp([]);
    }
  };

  const onSubmit = (data) => {
    if (!data.PartyId) {
      toast.error("Please fill all mandatory fields");
      return;
    }
    stepToNext({
      ...data,
      PropertyId: parseInt(data.PropertyId) || 0,
      PropertyName: selectedProperty?.name || "",
      PartyId: parseInt(data.PartyId),
      PartyDtlId: parseInt(data.PartyDtlId) || 0,
      ActVendId: parseInt(data.ActualPartyId) || 0,
      ActVendDtlId: parseInt(data.ActualPartyDtlId) || 0,
      TrspId: parseInt(data.TrspId) || 0,
      BrokerId: parseInt(data.BrokerId) || 0,
      Amount: parseFloat(data.Amount) || 0,
      Quantity: parseFloat(data.Quantity) || 0,
    });
  };

  const handleCancel = async () => {
    try {
      if ((mode === "add" || mode === "edit") && GooodsId !== -1) {
        await UnLock(GooodsId, "TrnSgrn", "SgrnId");
      }
      viewModeDis();
      if (CompanyData.length > 0) {
        await fetchGoodsData(GooodsId, "R");
      } else {
        await fetchGoodsData(1, "L");
      }
    } catch (error) {
      toast.error("Failed to cancel operation");
    }
  };

  const handleSupplierChange = async (e) => {
    const selectedSupplierId = e.target.value;
    setValue("PartyId", selectedSupplierId);
  };

  const handleActualSupplierChange = async (e) => {
    const selectedSupplierId = e.target.value;
    setValue("ActualPartyId", selectedSupplierId);
    await fetchActualBranches(selectedSupplierId);
    setValue("ActualPartyDtlId", "");
  };

  const handleBranchChange = (e) => {
    const selectedBranchId = e.target.value;
    setValue("ActualPartyDtlId", selectedBranchId);
  };

  const handleActualBranchChange = (e) => {
    const selectedBranchId = e.target.value;
    setValue("ActualPartyDtlId", selectedBranchId);
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await getRoomMasterdropdata({
          Flag: "",
          UserId: userId,
        });
        if (response?.data?.Status === 0) {
          const dropdownItems = response.data.Data.map((item) => ({
            id: item.PropId,
            name: item.Name,
          }));
          setPropoption(dropdownItems);
          // if (dropdownItems.length > 0) {
          //   setSelectedProperty(dropdownItems[0]);
          // }
        }
      } catch (error) {
        toast.error("Error fetching property data");
      }
    };

    fetchDropdownData();
  }, [userId]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "PropertyId" && value.PropertyId) {
        const property = propoption.find(prop => prop.id == value.PropertyId);
        if (property) {
          setSelectedProperty(property);
        }
      }
      if (name === "ActualPartyId" && value.ActualPartyId) {
        fetchActualBranches(value.ActualPartyId);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, propoption]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} md={11} lg={11}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Box sx={{ mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    id="property-selector"
                    options={propoption}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedProperty}
                    onChange={(event, newValue) => {
                      setSelectedProperty(newValue);
                      setValue("PropertyId", newValue?.id || "");
                    }}
                    disabled={AllTextDisabled}
                    noOptionsText="No properties found"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        label={
                          <>
                            Property
                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                          </>
                        }
                        placeholder="Search property..."
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <InputAdornment position="start">
                                <SearchIcon color="action" />
                              </InputAdornment>
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                          }
                        }}
                      />
                    )}
                  />

                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="GRN No"
                    name="SgrnNo"
                    variant="outlined"
                    size="small"
                    {...register("SgrnNo")}
                    // disabled={AllTextDisabled}
                    disabled={true}
                    InputLabelProps={{
                      shrink: !!watch("SgrnNo"),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: 'action.disabledBackground'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="GRN Date"
                    name="SgrnDt"
                    type="date"
                    value={watch("SgrnDt")}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    disabled={AllTextDisabled}
                    {...register("SgrnDt")}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="Reference No"
                    name="RefNo"
                    variant="outlined"
                    size="small"
                    {...register("RefNo")}
                    disabled={AllTextDisabled}
                    InputLabelProps={{ shrink: Boolean(watch("RefNo")) }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>

                  <Autocomplete
                    id="supplier-autocomplete"
                    options={supplierDrp}
                    getOptionLabel={(option) => option.Name || ""}
                    value={supplierDrp.find(supplier => supplier.Id === watch("PartyId")) || null}
                    onChange={(event, newValue) => {
                      setValue("PartyId", newValue?.Id || "");
                      if (newValue) {
                        handleSupplierChange({ target: { value: newValue.Id } });
                      }
                    }}
                    disabled={AllTextDisabled || loading}
                    noOptionsText="No suppliers found"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        label={
                          <>
                            Supplier Name
                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                          </>
                        }
                        placeholder="Search supplier..."
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <InputAdornment position="start">
                                <SearchIcon color="action" />
                              </InputAdornment>
                              {params.InputProps.startAdornment}
                            </>
                          ),
                          endAdornment: (
                            <>
                              {!AllTextDisabled && (
                                <>
                                  <InputAdornment position="end">
                                    <AddIcon
                                      onClick={openNewTab}
                                      style={{ cursor: "pointer", fontSize: '20px', color: 'blue' }} // Set appropriate color
                                    />
                                  </InputAdornment>
                                  <InputAdornment position="end">
                                    <RefreshIcon
                                      onClick={fetchSuppliers}
                                      style={{ cursor: "pointer", fontSize: '17px', color: 'green' }} // Set appropriate color
                                    />
                                  </InputAdornment>
                                </>
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            // backgroundColor: AllTextDisabled || loading ? 'action.disabledBackground' : 'background.paper',
                          },
                          "& .MuiInputBase-input": {
                            paddingRight: '0px', // Ensure text doesn't overlap with icons
                          }
                        }}
                      />
                    )}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel id="PartyDtlId-select-label">Branch</InputLabel>
                    <Select
                      labelId="PartyDtlId-select-label"
                      id="PartyDtlId"
                      value={watch("PartyDtlId") || ""}
                      onChange={handleBranchChange}
                      disabled={AllTextDisabled || loading || branchDrp.length === 0}
                      label="Branch"
                      sx={{
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled || loading ? 'action.disabledBackground' : 'background.paper',
                        paddingRight: '30px', // Ensure there's enough space for the icons
                      }}

                    // endAdornment={
                    //   <InputAdornment position="end">
                    //      <AddIcon
                    //   onClick={openBranchTab}
                    //   style={{ cursor: "pointer", fontSize: '20px', marginRight: '8px' }}
                    // />
                    // <RefreshIcon
                    //   onClick={handleRefreshSuppliers}
                    //   style={{ cursor: "pointer", fontSize: '17px' }}
                    // />
                    //   </InputAdornment>
                    // }
                    >
                      {branchDrp.map((branch) => (
                        <MenuItem key={branch.Id} value={branch.Id}>
                          {branch.Name}
                        </MenuItem>
                      ))}
                    </Select>

                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    id="actual-supplier-autocomplete"
                    options={supplierDrp}
                    getOptionLabel={(option) => option.Name || ""}
                    value={supplierDrp.find(supplier => supplier.Id === watch("ActualPartyId")) || null}
                    onChange={(event, newValue) => {
                      setValue("ActualPartyId", newValue?.Id || "");
                      if (newValue) {
                        handleActualSupplierChange({ target: { value: newValue.Id } });
                      }
                    }}
                    disabled={AllTextDisabled || loading}
                    noOptionsText="No suppliers found"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        label={
                          <>
                            Actual Supplier
                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                          </>
                        }
                        placeholder="Search actual supplier..."
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <InputAdornment position="start">
                                <SearchIcon color="action" />
                              </InputAdornment>
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            // backgroundColor: AllTextDisabled || loading ? 'action.disabledBackground' : 'background.paper'
                          }
                        }}
                      />
                    )}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel id="ActualPartyDtlId-select-label">Actual Branch</InputLabel>
                    <Select
                      labelId="ActualPartyDtlId-select-label"
                      id="ActualPartyDtlId"
                      value={watch("ActualPartyDtlId") || ""}
                      onChange={handleActualBranchChange}
                      disabled={AllTextDisabled || loading || actualBranchDrp.length === 0}
                      label="Actual Branch"
                    >
                      {actualBranchDrp.map((branch) => (
                        <MenuItem key={branch.Id} value={branch.Id}>
                          {branch.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Challan /Bill No."
                    name="ChallanNo"
                    variant="outlined"
                    size="small"
                    {...register("ChallanNo")}
                    disabled={AllTextDisabled}
                    InputLabelProps={{ shrink: Boolean(watch("ChallanNo")) }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Challan Date"
                    name="ChallanDt"
                    type="date"
                    value={watch("ChallanDt")}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    disabled={AllTextDisabled}
                    {...register("ChallanDt")}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="LR No"
                    name="LrNo"
                    variant="outlined"
                    size="small"
                    {...register("LrNo")}
                    disabled={AllTextDisabled}
                    InputLabelProps={{ shrink: Boolean(watch("LrNo")) }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="LR Date"
                    name="LrDt"
                    type="date"
                    value={watch("LrDt")}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    disabled={AllTextDisabled}
                    {...register("LrDt")}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel id="TrspId-select-label">Transporter</InputLabel>
                    <Select
                      labelId="TrspId-select-label"
                      id="TrspId"
                      name="TrspId"
                      value={watch("TrspId") || ""}
                      onChange={(e) => setValue("TrspId", e.target.value)}
                      disabled={AllTextDisabled || loading}
                      label="Transporter"

                      sx={{
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled || loading ? 'action.disabledBackground' : 'background.paper',
                        paddingRight: '30px', // Ensure there's enough space for the icons
                      }}
                      {...register("TrspId")}
                    // endAdornment={
                    //   <InputAdornment position="end">
                    //     <AddIcon
                    //       onClick={openTransportTab}
                    //       style={{ cursor: "pointer", fontSize: '20px' }}
                    //     />
                    //     <RefreshIcon
                    //       onClick={handleRefreshTransporters}
                    //       style={{ cursor: "pointer", fontSize: '17px' }}
                    //     />
                    //   </InputAdornment>
                    // }
                    >
                      {transportDrp.map((transporter) => (
                        <MenuItem key={transporter.Id} value={transporter.Id}>
                          {transporter.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel id="BrokerId-select-label">Broker</InputLabel>
                    <Select
                      labelId="BrokerId-select-label"
                      id="BrokerId"
                      name="BrokerId"
                      value={watch("BrokerId") || ""}
                      onChange={(e) => setValue("BrokerId", e.target.value)}
                      disabled={AllTextDisabled || loading}
                      label="Broker"
                      sx={{
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled || loading ? 'action.disabledBackground' : 'background.paper'
                      }}
                      {...register("BrokerId")}
                    >
                      {brokerDrp.map((broker) => (
                        <MenuItem key={broker.Id} value={broker.Id}>
                          {broker.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Quantity"
                    name="Quantity"
                    type="number"
                    variant="outlined"
                    size="small"
                    step="0.01"
                    {...register("Quantity")}
                    // disabled={AllTextDisabled}
                    disabled={true}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: 'action.disabledBackground'
                      }
                    }}
                  // sx={{
                  //   '& .MuiOutlinedInput-root': {
                  //     borderRadius: 1,
                  //     backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                  //   }
                  // }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Amount"
                    name="Amount"
                    type="number"
                    variant="outlined"
                    size="small"
                    step="0.01"
                    {...register("Amount")}
                    disabled={true}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: 'action.disabledBackground'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Remark"
                    name="Remark"
                    variant="outlined"
                    size="small"
                    multiline
                    rows={2}
                    {...register("Remark")}
                    disabled={AllTextDisabled}
                    InputLabelProps={{ shrink: Boolean(watch("Remark")) }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        // backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                disabled={AllTextDisabled || loading}
                sx={{
                  px: 3,
                  fontWeight: 600,
                  borderRadius: 1,
                  boxShadow: 'none',
                  '&:hover': { boxShadow: 'none' }
                }}
              >
                Next
              </Button>
              <Button
                variant="outlined"
                size="medium"
                onClick={handleCancel}
                disabled={AllTextDisabled || loading}
                sx={{
                  px: 3,
                  fontWeight: 600,
                  borderRadius: 1,
                  borderWidth: 2,
                  '&:hover': { borderWidth: 2 }
                }}
              >
                Cancel
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </form>
  );
};

export default GRNStep1;